export const mockProducts = [
  {
    id: 1,
    name: 'Double-Sided Polyester Tape',
    code: 'ST 0102',
    category: 'polyester',
    image: '/site-assets/poly2.jpg',
    description: 'High-quality double-sided polyester tape with premium polyester film and high-performance adhesive on both sides for exceptional bonding strength.',
    variants: [
      {
        name: 'I Bonding D/S Polyester Tape 165 Mic',
        description: 'Intended for precision laminating and lightweight bonding applications.'
      },
      {
        name: 'I Bonding D/S Polyester Tape 180 Mic',
        description: 'Provides increased thickness and strength for applications requiring additional durability.'
      }
    ],
    features: [
      'Exceptional resistance to heat, aging and chemicals',
      'Consistent performance and durability',
      'Clean, dependable adhesion free of residual',
      'Available in customized widths'
    ],
    applications: [
      'Mounting and laminating',
      'Splicing and joining',
      'Automotive applications',
      'Electronics and printing',
      'Packaging and construction'
    ]
  },
  {
    id: 2,
    name: 'Green Polyester Tape',
    code: 'ST 0103',
    category: 'polyester',
    image: '/site-assets/poly1.jpg',
    description: 'High-quality green masking tape for high-temperature applications with durable polyester film backing and robust silicone adhesive.',
    variants: [
      {
        name: 'Green Polyester Tape 1mil',
        description: 'Optimal for delicate masking applications requiring precise, thin coverage.'
      },
      {
        name: 'Green Polyester Tape 2mil',
        description: 'Offers supplementary durability and strength for rigorous concealing procedures.'
      },
      {
        name: 'Green Polyester Tape with Liner 2mil',
        description: 'Engineered for effortless handling and die-cutting for automated masking tasks.'
      }
    ],
    features: [
      'Withstands severe heat and chemicals',
      'Excellent adhesion on various surfaces',
      'Clean removal without residue',
      'Resistant to mechanical stress'
    ],
    applications: [
      'Powder coating',
      'Anodizing and electroplating',
      'Painting processes',
      'Automotive and aerospace',
      'Electronics manufacturing'
    ]
  },
  {
    id: 3,
    name: 'Polyester Electrical Insulation Tape',
    code: 'ST-A101',
    category: 'insulation',
    image: '/site-assets/poly3.jpg',
    description: 'Electrical insulation adhesive tapes with superior thermal resistance and high dielectric strength for critical electrical applications.',
    variants: [
      {
        name: 'Yellow Polyester Tape 1 mil',
        description: 'Reliable insulation with clear identification for wiring tasks.'
      },
      {
        name: 'Red Polyester Tape 1 mil',
        description: 'Strong insulation and easy electrical assembly color tagging.'
      },
      {
        name: 'Blue Polyester Tape 1 mil',
        description: 'Durable insulation and quick harnessing identification.'
      },
      {
        name: 'Black Polyester Tape 1 mil',
        description: 'Useful general insulation option.'
      },
      {
        name: 'Green Polyester Tape 1 mil',
        description: 'Constant insulation with color difference.'
      }
    ],
    features: [
      'Temperature range: 90°C to 260°C',
      'Superior electrical insulation properties',
      'Resistance to varnish & chemicals',
      'Available in multiple colors for identification'
    ],
    applications: [
      'Coils and transformers',
      'Electrical motors & generators',
      'Capacitor manufacturing',
      'Traction motors',
      'Phase and slot insulation'
    ]
  },
  {
    id: 4,
    name: 'EPDM Foam Tape',
    code: 'ST 0403',
    category: 'foam',
    image: '/site-assets/epdm.jpg',
    description: 'High-quality EPDM foam tape with excellent heat resistance, durability, and weatherproofing for sealing applications.',
    variants: [
      {
        name: 'Single Side EPDM Black Foam Tape – 2mm to 12mm',
        description: 'Seals water, air, and dust well. Resists heat & weather.'
      },
      {
        name: 'Single Side EPDM Black Foam Tape Reinforce – 2mm to 12mm',
        description: 'For tough industrial sealing and insulation applications.'
      }
    ],
    features: [
      'Excellent weatherproofing',
      'UV exposure resistance',
      'Superior elasticity',
      'Energy efficient sealing'
    ],
    applications: [
      'Glass and gasket applications',
      'HVAC systems',
      'Automotive sealing',
      'Indoor and outdoor use',
      'Industrial sealing'
    ]
  },
  {
    id: 5,
    name: 'Neoprene Foam Tape',
    code: 'ST 0409',
    category: 'foam',
    image: '/site-assets/neo.jpg',
    description: 'Neoprene foam tape with adaptability and resilience for high-rise buildings, refrigeration, and air conditioning systems.',
    variants: [
      {
        name: 'Single Side Neoprene Black Foam Tape – 2mm to 12mm',
        description: 'Seals, cushions, and insulates for industrial & construction applications.'
      },
      {
        name: 'Single Side Neoprene Black Foam Tape Reinforce – 2mm to 12mm',
        description: 'For heavy-duty sealing & protection.'
      }
    ],
    features: [
      'Weather and moisture resistant',
      'Shock absorption',
      'Vibration reduction',
      'Airtight seals'
    ],
    applications: [
      'High-rise buildings',
      'Refrigeration units',
      'Air conditioning systems',
      'Construction and HVAC',
      'Electronic applications'
    ]
  },
  {
    id: 6,
    name: 'Nitrile Foam Tape',
    code: 'ST 0407',
    category: 'foam',
    image: '/site-assets/nitrile.jpg',
    description: 'Closed-cell nitrile foam tape with strong acrylic adhesive for HVAC applications and piping insulation.',
    variants: [
      {
        name: 'Single Side Nitrile Black Foam Tape – 1mm to 10mm',
        description: 'Robust insulation, sealing, and resistance to heat, oil, and weather.'
      }
    ],
    features: [
      'Resistance to heat, oil, and fuel',
      'Self-adhesive for easy installation',
      'Vibration and condensation resistance',
      'Industrial-grade durability'
    ],
    applications: [
      'HVAC systems',
      'Piping insulation',
      'Plumbing applications',
      'Air conditioning',
      'Refrigeration'
    ]
  },
  {
    id: 7,
    name: 'XLPE Foam Tape',
    code: 'ST-D101',
    category: 'foam',
    image: '/site-assets/neo.jpg',
    description: 'Cross-linked polyethylene foam tape providing cushioning, sealing, and thermal insulation for various applications.',
    variants: [
      {
        name: 'Single Side XLPE Black Foam Tape – 1mm to 18mm',
        description: 'Durable sealing, cushioning, and insulating for industrial applications.'
      },
      {
        name: 'Single Side XLPE White Foam Tape – 1mm to 18mm',
        description: 'Clean finish for mounting, gasketing, and precision sealing.'
      },
      {
        name: 'Single Side XLPE Black Foam Tape with Reinforce – 1mm to 18mm',
        description: 'Strong and stable for heavy-duty sealing.'
      },
      {
        name: 'Double Side XLPE Black Foam Tape – 1mm to 18mm',
        description: 'Double-sided bonding for industrial & building settings.'
      },
      {
        name: 'Double Side XLPE White Foam Tape – 1mm to 18mm',
        description: 'Clean finish with strong adhesion on both sides.'
      }
    ],
    features: [
      'Weather and UV resistant',
      'Chemical resistance',
      'Strong adhesive backing',
      'Closed-cell structure'
    ],
    applications: [
      'HVAC systems',
      'Building projects',
      'Automotive industry',
      'Electronic assemblies',
      'Gasketing and mounting'
    ]
  },
  {
    id: 8,
    name: 'Cross Filament Tape',
    code: 'ST 0105',
    category: 'specialty',
    image: '/site-assets/cross-filament.jpeg',
    description: 'Fiberglass reinforced tape with remarkable durability for load securing, palletizing, and heavy-duty packing.',
    variants: [
      {
        name: 'Cross Filament Tape – 150 mic',
        description: 'Resists high tension and offers maximum reinforcement for industrial use.'
      }
    ],
    features: [
      'Excellent grip and impact resistance',
      'High tensile strength',
      'Tear resistance',
      'Durable adhesive backing'
    ],
    applications: [
      'Load securing',
      'Palletizing',
      'Metal bundling',
      'Heavy-duty packing',
      'Shipping and logistics'
    ]
  },
  {
    id: 9,
    name: 'Polyimide Tape (Kapton)',
    code: 'ST 0104',
    category: 'specialty',
    image: '/site-assets/polyimide.png',
    description: 'High-performance Kapton tape with exceptional thermal stability and electrical insulation for extreme environments.',
    variants: [
      {
        name: 'Polymide Tape 1 mil',
        description: 'Ideal for high-temperature masking and precision insulation.'
      },
      {
        name: 'Polymide Tape 2 mil',
        description: 'Adds thickness and endurance for tough thermal insulation.'
      },
      {
        name: 'Polymide Tape With Liner 2 mil',
        description: 'Easy handling and die-cutting for specialized processes.'
      },
      {
        name: 'Double Side Polymide Tape 0.095mm',
        description: 'Strong adhesion on both sides for high-heat bonding.'
      }
    ],
    features: [
      'Exceptional thermal stability',
      'Outstanding chemical resistance',
      'Excellent dielectric strength',
      'Withstands prolonged heat exposure'
    ],
    applications: [
      'Circuit board insulation',
      'High-temperature masking',
      'Coil wrapping',
      'Soldering processes',
      'Aerospace applications'
    ]
  },
  {
    id: 10,
    name: 'Aluminum Foil Tape',
    code: 'ST-AF01',
    category: 'specialty',
    image: '/site-assets/aluminum.jpg',
    description: 'Aluminum foil tape with heat conductivity and reflectiveness for industrial sealing and insulation.',
    variants: [
      {
        name: 'Aluminum Tape 30mic + 20mic',
        description: 'Lightweight and sturdy for sealing and insulation.'
      },
      {
        name: 'Aluminum Tape 50mic + 30mic',
        description: 'Stronger bonding for demanding industrial applications.'
      },
      {
        name: 'Aluminum Tape 100mic + 30mic with liner',
        description: 'Ultimate strength for extreme resistance.'
      }
    ],
    features: [
      'Excellent heat conductivity',
      'Moisture and chemical resistant',
      'UV radiation resistance',
      'Reflective surface'
    ],
    applications: [
      'HVAC systems',
      'Thermal insulation',
      'Duct sealing',
      'EMI/RFI shielding',
      'Aerospace and automotive'
    ]
  },
  {
    id: 11,
    name: 'Glass Cloth Tape',
    code: 'ST-GC01',
    category: 'insulation',
    image: '/site-assets/glass.png',
    description: 'Glass fabric tape with high mechanical strength and heat resistance for challenging industrial environments.',
    variants: [
      {
        name: 'Glass Cloth Tape 0.18mm',
        description: 'Strong heat-resistant tape for high-temperature protection.'
      },
      {
        name: 'Double Side Glass Cloth Tape 0.18mm',
        description: 'Dual-sided adhesion for industrial bonding and insulation.'
      }
    ],
    features: [
      'High dielectric strength',
      'Chemical stability',
      'Resistance to tearing',
      'High and low temperature resistance'
    ],
    applications: [
      'Electrical insulation',
      'Coil wrapping',
      'Motor and transformer applications',
      'High-temperature masking',
      'Sealing'
    ]
  },
  {
    id: 12,
    name: 'Duct Tape',
    code: 'ST-DT01',
    category: 'specialty',
    image: '/site-assets/duct.png',
    description: 'Premium duct tape with durability and adaptability for quick repairs, bundling, and sealing applications.',
    variants: [
      {
        name: 'Duct Tape Grey – 160 mic',
        description: 'Sturdy tape for packing and general-purpose sealing.'
      },
      {
        name: 'Duct Tape Black – 160 mic',
        description: 'Heavy-duty tape for industrial and utility applications.'
      }
    ],
    features: [
      'Exceptional holding power',
      'Weather and moisture resistant',
      'Easy-to-tear',
      'Strong and flexible'
    ],
    applications: [
      'Quick repairs',
      'Bundling',
      'Construction',
      'Packaging',
      'General-purpose sealing'
    ]
  },
  {
    id: 13,
    name: 'CLS Foam Tapes',
    code: 'ST-D101',
    category: 'foam',
    image: '/site-assets/cls-foam-tape.jpg',
    description: 'Cross-linked closed-cell foam tapes available in single and double-sided options with reinforcement variants.',
    variants: [
      { name: 'ST-D101: S/SIDE CLS FOAM TAPES BLACK AND WHITE', description: 'Single-sided closed-cell foam tape.' },
      { name: 'ST-D102: D/SIDE CLS FOAM TAPES BLACK AND WHITE', description: 'Double-sided closed-cell foam tape.' },
      { name: 'ST-D103: S/SIDE CLS REINFORCEMENT FOAM TAPES (Glass FABRIC)', description: 'Single-sided with glass fabric reinforcement.' },
      { name: 'ST-D104: D/SIDE CLS REINFORCEMENT FOAM TAPES (Glass FABRIC)', description: 'Double-sided with glass fabric reinforcement.' },
      { name: 'ST-D105: S/SIDE CLS REINFORCEMENT FOAM TAPES (Polyester FABRIC)', description: 'Single-sided with polyester fabric reinforcement.' },
      { name: 'ST-D106: D/SIDE CLS REINFORCEMENT FOAM TAPES (Polyester FABRIC)', description: 'Double-sided with polyester fabric reinforcement.' }
    ],
    features: [
      'Excellent cushioning and sealing',
      'Available with fabric reinforcement',
      'Single and double-sided options',
      'Black and white color options'
    ],
    applications: [
      'Holding and temporary fixing',
      'Component mounting',
      'Refrigerator assembly',
      'Industrial sealing'
    ]
  },
  {
    id: 14,
    name: 'EPDM Rubber Foam Tapes (Extended Range)',
    code: 'ST-D107',
    category: 'foam',
    image: '/site-assets/epdm.jpg',
    description: 'Extended range of EPDM rubber foam tapes with single/double-sided and reinforcement options.',
    variants: [
      { name: 'ST-D107: S/SIDE EPDM RUBBER FOAM TAPES', description: 'Single-sided EPDM rubber foam tape.' },
      { name: 'ST-D108: D/SIDE EPDM RUBBER FOAM TAPES', description: 'Double-sided EPDM rubber foam tape.' },
      { name: 'ST-D109: S/SIDE EPDM REINFORCEMENT FOAM TAPES (Polyester FABRIC)', description: 'Single-sided with polyester reinforcement.' },
      { name: 'ST-D110: D/SIDE EPDM REINFORCEMENT FOAM TAPES (Polyester FABRIC)', description: 'Double-sided with polyester reinforcement.' },
      { name: 'ST-D111: S/SIDE EPDM REINFORCEMENT FOAM TAPES (Glass FABRIC)', description: 'Single-sided with glass fabric reinforcement.' },
      { name: 'ST-D112: D/SIDE EPDM REINFORCEMENT FOAM TAPES (Glass FABRIC)', description: 'Double-sided with glass fabric reinforcement.' }
    ],
    features: [
      'Superior weatherproofing',
      'Fabric reinforcement options',
      'UV and heat resistant',
      'Multiple configuration options'
    ],
    applications: [
      'HVAC sealing',
      'Automotive gaskets',
      'Industrial weather sealing',
      'Outdoor applications'
    ]
  },
  {
    id: 15,
    name: 'Neoprene Rubber Foam Tapes (Extended Range)',
    code: 'ST-D113',
    category: 'foam',
    image: '/site-assets/neo.jpg',
    description: 'Comprehensive range of neoprene rubber foam tapes with reinforcement and dual-sided options.',
    variants: [
      { name: 'ST-D113: S/SIDE NEOPRINE RUBBER FOAM TAPES', description: 'Single-sided neoprene rubber foam tape.' },
      { name: 'ST-D114: D/SIDE NEOPRINE RUBBER FOAM TAPES', description: 'Double-sided neoprene rubber foam tape.' },
      { name: 'ST-D115: S/SIDE NEOPRINE REINFORCEMENT FOAM TAPES (Polyester FABRIC)', description: 'Single-sided with polyester reinforcement.' },
      { name: 'ST-D116: D/SIDE NEOPRINE REINFORCEMENT FOAM TAPES (Polyester FABRIC)', description: 'Double-sided with polyester reinforcement.' },
      { name: 'ST-D117: S/SIDE NEOPRINE REINFORCEMENT FOAM TAPES (Glass FABRIC)', description: 'Single-sided with glass fabric reinforcement.' },
      { name: 'ST-D118: D/SIDE NEOPRINE REINFORCEMENT FOAM TAPES (Glass FABRIC)', description: 'Double-sided with glass fabric reinforcement.' }
    ],
    features: [
      'Excellent shock absorption',
      'Reinforcement options available',
      'Weather resistant',
      'Vibration dampening'
    ],
    applications: [
      'Construction sealing',
      'HVAC applications',
      'Refrigeration units',
      'Industrial mounting'
    ]
  },
  {
    id: 16,
    name: 'Silicon Rubber Foam Tape',
    code: 'ST-D119',
    category: 'foam',
    image: '/site-assets/neo.jpg',
    description: 'Premium silicon rubber foam tape with exceptional temperature resistance and sealing properties.',
    features: [
      'High temperature resistance',
      'Excellent chemical resistance',
      'Superior sealing performance',
      'Flexible and durable'
    ],
    applications: [
      'High-temperature sealing',
      'Gasket applications',
      'Industrial insulation',
      'Automotive applications'
    ]
  },
  {
    id: 18,
    name: 'IXPE Foam Tape',
    code: 'ST-D121',
    category: 'foam',
    image: '/site-assets/neo.jpg',
    description: 'IXPE (Irradiated Cross-linked Polyethylene) foam tape with superior cushioning and sealing capabilities.',
    variants: [
      { name: 'ST-D121: S/SIDE IXPE FOAM TAPE', description: 'Single-sided IXPE foam tape.' },
      { name: 'ST-D122: D/SIDE IXPE FOAM TAPE', description: 'Double-sided IXPE foam tape.' }
    ],
    features: [
      'Lightweight cushioning',
      'Moisture resistance',
      'Closed-cell structure',
      'Easy to apply'
    ],
    applications: [
      'Mounting applications',
      'Sound insulation',
      'Thermal insulation',
      'Packaging protection'
    ]
  },
  {
    id: 19,
    name: 'Nitrile Foam Tape (Extended)',
    code: 'ST-D123',
    category: 'foam',
    image: '/site-assets/nitrile.jpg',
    description: 'Single-sided nitrile foam tape with excellent oil and heat resistance for industrial applications.',
    features: [
      'Oil and fuel resistant',
      'Heat resistant',
      'Chemical resistant',
      'Industrial-grade adhesive'
    ],
    applications: [
      'HVAC insulation',
      'Piping applications',
      'Industrial sealing',
      'Refrigeration'
    ]
  },
  {
    id: 20,
    name: 'PU Foam Tape',
    code: 'ST-D124',
    category: 'foam',
    image: '/site-assets/neo.jpg',
    description: 'Polyurethane foam tape available in flame retardant (FR) and non-flame retardant variants.',
    variants: [
      { name: 'PU FOAM TAPE FR', description: 'Flame retardant polyurethane foam tape for safety-critical applications.' },
      { name: 'PU FOAM TAPE NON FR', description: 'Standard polyurethane foam tape for general applications.' }
    ],
    features: [
      'Available in FR and Non-FR variants',
      'Excellent cushioning',
      'Good adhesion properties',
      'Flexible and conformable'
    ],
    applications: [
      'Electronics assembly',
      'Automotive interiors',
      'Construction applications',
      'Mounting and gasketing'
    ]
  },
  {
    id: 28,
    name: 'Die Cuts',
    code: 'ST-DC01',
    category: 'specialty',
    image: '/site-assets/diecut.jpeg',
    description: 'Custom die-cut adhesive solutions in various shapes, sizes, and materials for precision applications.',
    features: [
      'Custom shapes and sizes',
      'Multiple material options',
      'Precision cutting',
      'Various adhesive strengths',
      'Available in rolls or individual pieces',
      'Custom colors and patterns'
    ],
    applications: [
      'Electronics assembly',
      'Automotive components',
      'Medical device manufacturing',
      'Industrial assembly',
      'Gasket and sealing applications',
      'Packaging and labeling'
    ]
  },
  {
    id: 21,
    name: 'Polyester Insulation Adhesive Tapes (Extended Range)',
    code: 'ST-A101',
    category: 'insulation',
    image: '/site-assets/poly3.jpg',
    description: 'Comprehensive range of polyester insulation adhesive tapes with various thickness and adhesive options for electrical applications.',
    variants: [
      { name: 'ST-A101: 1mil Coloured Polyester (White Adh) Insulation Adhesive Tape', description: 'Color-coded with white adhesive for easy identification.' },
      { name: 'ST-A102: 1mil Polyester Insulation Adhesive Tape', description: 'Standard 1mil polyester insulation tape.' },
      { name: 'ST-A103: 2 mil Polyester Insulation Adhesive Tape', description: 'Enhanced thickness for additional protection.' }
    ],
    features: [
      'Multiple thickness options',
      'Color coding available',
      'Excellent electrical insulation',
      'Heat resistant'
    ],
    applications: [
      'Motor winding insulation',
      'Transformer applications',
      'Electrical component protection',
      'Wire harnessing'
    ]
  },
  {
    id: 22,
    name: 'Glass Cloth Insulation Adhesive Tape [Class H]',
    code: 'ST-A104',
    category: 'insulation',
    image: '/site-assets/glass.png',
    description: 'High-temperature Class H glass cloth insulation tapes for extreme thermal applications up to 260°C.',
    variants: [
      { name: 'ST-A104-260°C: Glass cloth Insulation Adhesive Tape [Class H]', description: 'Single-sided glass cloth tape rated to 260°C.' },
      { name: 'ST-A105-200°C: Double Sided Glass cloth Insulation Adhesive Tape [Class H]', description: 'Double-sided glass cloth tape rated to 200°C.' }
    ],
    features: [
      'Class H temperature rating',
      'Up to 260°C operating temperature',
      'Excellent dielectric strength',
      'Single and double-sided options'
    ],
    applications: [
      'High-temperature motor insulation',
      'Transformer core insulation',
      'Class H rated equipment',
      'Extreme environment applications'
    ]
  },
  {
    id: 23,
    name: 'Rayon Fabric Insulation Adhesive Tape',
    code: 'ST-A106',
    category: 'insulation',
    image: '/site-assets/poly3.jpg',
    description: 'Rayon fabric-based insulation tapes with excellent conformability and electrical insulation properties.',
    variants: [
      { name: 'ST-A106: Pink / Black Rayon Fabric Insulation Adhesive Tape', description: 'Available in pink or black for identification.' },
      { name: 'ST-A107: Pink Rayon (Blended) Fabric Insulation Adhesive Tape', description: 'Blended rayon fabric for enhanced properties.' }
    ],
    features: [
      'Excellent conformability',
      'Tear resistant fabric backing',
      'Good electrical insulation',
      'Multiple color options'
    ],
    applications: [
      'Cable bundling',
      'Electrical insulation',
      'Wire harness assembly',
      'General electrical applications'
    ]
  },
  {
    id: 24,
    name: 'Polyimide Film Insulation Adhesive Tape [Class H]',
    code: 'ST-A108',
    category: 'specialty',
    image: '/site-assets/polyimide.png',
    description: 'Premium polyimide (Kapton) film insulation tapes with Class H temperature rating for demanding applications.',
    variants: [
      { name: 'ST-A108: 1 mil Polyimide film Insulation Adhesive Tape [Class H]', description: 'Thin profile for precision applications.' },
      { name: 'ST-A109: 2 mil Polyimide film Insulation Adhesive Tape [Class H]', description: 'Standard thickness for general use.' },
      { name: 'ST-A110: 3 mil Polyimide film Insulation Adhesive Tape [Class H]', description: 'Extra thickness for demanding applications.' },
      { name: 'ST-A111: 2 mil with liner Polyimide film Insulation Adhesive Tape [Class H]', description: 'With liner for easy handling and die-cutting.' },
      { name: 'ST-A112: 3.8mil Double sided Polymide film Insulation tape [Class H]', description: 'Double-sided for bonding and insulation.' }
    ],
    features: [
      'Class H temperature rating',
      'Exceptional thermal stability',
      'Multiple thickness options',
      'Excellent chemical resistance'
    ],
    applications: [
      'Circuit board masking',
      'High-temperature bonding',
      'Aerospace applications',
      'Advanced electronics manufacturing'
    ]
  },
  {
    id: 25,
    name: 'Mono Filament Adhesive Tape',
    code: 'ST-A113',
    category: 'specialty',
    image: '/site-assets/cross.png',
    description: 'High-strength mono filament tape with exceptional tensile strength for bundling and strapping applications.',
    features: [
      'Single-direction tensile strength',
      'Excellent tear resistance',
      'Strong adhesive backing',
      'Fiberglass reinforcement'
    ],
    applications: [
      'Heavy-duty bundling',
      'Strapping applications',
      'Palletizing',
      'Load securing'
    ]
  },
  {
    id: 26,
    name: 'Double Sided Release Coated Polyester Film',
    code: 'ST-A114',
    category: 'specialty',
    image: '/site-assets/poly2.jpg',
    description: 'Release coated polyester film available in various thicknesses for lamination and release applications.',
    variants: [
      { name: '25mic Double Sided Release Coated Polyester Film', description: 'Thin release film for precision applications.' },
      { name: '50mic Double Sided Release Coated Polyester Film', description: 'Medium thickness release film.' },
      { name: '75mic Double Sided Release Coated Polyester Film', description: 'Standard thickness for general use.' },
      { name: '100mic Double Sided Release Coated Polyester Film', description: 'Heavy-duty release film.' }
    ],
    features: [
      'Range: 25mic to 100mic',
      'Double-sided release coating',
      'Smooth surface finish',
      'Easy release properties'
    ],
    applications: [
      'Lamination processes',
      'Release liner applications',
      'Die-cutting',
      'Manufacturing processes'
    ]
  },
  {
    id: 27,
    name: 'Kapton (Polyimide) Non-Adhesive Insulation Tape',
    code: 'ST-A115',
    category: 'specialty',
    image: '/site-assets/polyimide.png',
    description: '1 mil Kapton polyimide non-adhesive insulation tape for high-temperature applications without adhesive.',
    features: [
      'No adhesive for clean applications',
      'High-temperature resistance',
      '1 mil thickness',
      'Excellent dielectric properties'
    ],
    applications: [
      'Slot liners',
      'Phase insulation',
      'High-temperature barriers',
      'Clean room applications'
    ]
  }
];